export const FILTER_TYPES_MAP = {
	SINGLE_CHOICE: 'singleChoice',
	MULTIPLE_CHOICE: 'multipleChoice',
	RANGE: 'range',
	DATE: 'date',
	DATE_RANGE: 'dateRange',
	PERIOD: 'period', // значение для фильтрации по периоду в формате массива двух iso строк 'YYYY-MM-DDTHH:mm:ssZ'
	DURATION: 'duration', // значение для фильтрации по длительности в формате строки 'HH:mm:ss'
	GLOB_FILTER_DATE_RANGE: '__ao__dateRange',
	BOOLEAN: 'boolean',
	SEARCH: 'search'
}

export const FILTER_COMPONENTS_MAP = {
	CHECKBOXES: 'ao-checkboxes',
	RADIOS: 'ao-radios',
	RANGE_SLIDERS: 'ao-range-sliders',
	DATE_PICKER: 'ao-date-picker',
	DATE_RANGE: 'ao-date-range-picker',
	V_SELECT: 'v-select',
	TEXT: 'ao-text-field'
}

export const ASYNC_FILTER_COMPONENTS_MAP = {
	LEGAL_ENTITIES: 'filteredByLegalEntities',
	MACHINE_GROUPS: 'filteredByMachineGroups',
	WORKS: 'filterByWorks',
	WORKS_CATEGORIES: 'filterByWorksCategories',
	CLUSTERS: 'filterByClusters',
	REGULATION_TAGS: 'filterByRegulationTags',
	MACHINES: 'filterByMachines',
	FIELDS: 'filterByFields',
	SATELLITE_IMAGE_DATES: 'filterBySatelliteImageDates',
	FIELD_TAGS: 'filterByFieldTags',
	INFRASTRUCTURE_TAGS: 'filterByInfrastructureTags',
}
